import { useMemo } from 'react'
import DinerLocationContext from 'apps/Diner/contexts/DinerLocation/DinerLocationContext'
import { useGetMerchantLocationQuery } from '__generated__/types'
import { useRouter } from 'next/router'

export default function DinerLocationProvider({
  children
}: {
  children: JSX.Element
}): JSX.Element {
  const router = useRouter()
  const { merchantLocationId } = router.query

  const { data, error } = useGetMerchantLocationQuery({
    variables: {
      merchantLocationId
    },
    skip: !merchantLocationId
  })

  const merchantLocation = data?.merchantLocation

  const contextValue = useMemo(() => {
    return { merchantLocation, error }
  }, [merchantLocation, error])

  return (
    <DinerLocationContext.Provider value={contextValue}>
      {children}
    </DinerLocationContext.Provider>
  )
}
